import alt from 'components/Dispatcher';

/**
 * SavedSearchActions are actions related to saved searches involving server endpoints
 * such as /api/v1/saved_searches, /api/v1/saved_search/{id}
 */
class SavedSearchActions {
  constructor() {
    this.generateActions(
      'deleteSavedSearch',
      'delete',
      'deleteLoading',
      'deleteSuccess',
      'deleteError',
      'executeInactiveSearch',
      'fetch',
      'fetchLoading',
      'fetchSuccess',
      'fetchError',
      'getSuccess',
      'getError',
      'mergeActiveIntoSearches',
      'persistCurrentSearch',
      'persistLoading',
      'persistSuccess',
      'persistError',
      'retrieveAndExecuteSavedSearch'
    );
  }
}

export default alt.createActions(SavedSearchActions);
